import { render } from "./CompteMessage.vue?vue&type=template&id=5bccc210&scoped=true"
import script from "./CompteMessage.vue?vue&type=script&lang=js"
export * from "./CompteMessage.vue?vue&type=script&lang=js"

import "./CompteMessage.vue?vue&type=style&index=0&id=5bccc210&scoped=true&lang=css"

import exportComponent from "/var/www/html/chatbot_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bccc210"]])

export default __exports__